// extracted by mini-css-extract-plugin
export default {"root":"tabbed-bar-module--root--a1ff4","tabSection":"tabbed-bar-module--tab-section--59965"};